import React, { PropsWithChildren } from 'react'

interface EmptyTableViewProps {
  message?: string
}

export function EmptyTableView (props: PropsWithChildren<EmptyTableViewProps>): React.JSX.Element {
  const { message = 'No data have been added to the table.', children } = props
  return (
    <div className={'empty-table-content'}>
      <p className={'empty-message'}>{message}</p>
      {children}
    </div>
  )
}
